import { render, staticRenderFns } from "./templatesDataExportWidget.vue?vue&type=template&id=1d6ff78a&scoped=true"
import script from "./templatesDataExportWidget.vue?vue&type=script&lang=js"
export * from "./templatesDataExportWidget.vue?vue&type=script&lang=js"
import style0 from "./templatesDataExportWidget.vue?vue&type=style&index=0&id=1d6ff78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6ff78a",
  null
  
)

export default component.exports